import { getRatingsAverage } from './ratings-utils';
export const getRatingsState = (state) => {
    return {
        total: state.total,
        average: getRatingsAverage(state),
        currentRating: state.currentRating.type === 'PENDING'
            ? {
                value: state.currentRating.pendingValue,
                isPending: true,
            }
            : { value: state.currentRating.value, isPending: false },
        inputRating: { value: state.inputRating, isPending: state.currentRating.type === 'PENDING' },
    };
};
export const getCurrentRating = (state) => state.currentRating.value;
//# sourceMappingURL=ratings-selectors.js.map